import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { VerContactosComponent } from "./ver-contactos/ver-contactos.component";
import { ContactoService } from "../../providers/contacto.service";
import { CrearContactoComponent } from "./crear-contacto/crear-contacto.component";
import { CrearContactoDialog } from "./crear-contacto/crear-contacto-dialog/crear-contacto-dialog.component";
import { ContactoComponent } from "./contacto/contacto.component";
import { EditarContactoComponent } from "./editar-contacto/editar-contacto.component";
import { EditarContactoDialog } from "./editar-contacto/editar-contacto-dialog/editar-contacto-dialog.component";
import { EliminarContactoComponent } from "./eliminar-contacto/eliminar-contacto.component";
import { EliminarContactoDialog } from "./eliminar-contacto/eliminar-contacto-dialog/eliminar-contacto-dialog.component";
import { AsignarContactoComponent } from "./asignar-contacto/asignar-contacto.component";
import { AsignarContactoDialog } from "./asignar-contacto/asignar-contacto-dialog/asignar-contacto-dialog.component";
import { DetalleContactoComponent } from './detalle-contacto/detalle-contacto.component';
import { RouterModule } from "@angular/router";
import { IncidenciaModule } from "../incidencias/incidencia.module";
// import { PropuestasService } from "../../providers/propuestas.service";
// import { VerEstadosPropuestaComponent } from "./ver-estados-propuesta/ver-estados-propuesta.component";
// import { CrearEstadoPropuestaComponent } from "./crear-estado-propuesta/crear-estado-propuesta.component";
// import { EstadoPropuestaComponent } from "./estado-propuesta/estado-propuesta.component";
// import { CrearEstadoPropuestaDialog } from "./crear-estado-propuesta/crear-estado-propuesta-dialog/crear-estado-propuesta-dialog.component";
// import { EditarEstadoPropuestaComponent } from "./editar-estado-propuesta/editar-estado-propuesta.component";
// import { EditarEstadoPropuestaDialog } from "./editar-estado-propuesta/editar-estado-propuesta-dialog/editar-estado-propuesta-dialog.component";
// import { OrdenEstadoPropuestaDialog } from "./ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component";
// import { EliminarEstadoPropuestaComponent } from "./eliminar-estado-propuesta/eliminar-estado-propuesta.component";
// import { EliminarEstadoPropuestaDialog } from "./eliminar-estado-propuesta/eliminar-estado-propuesta-dialog/eliminar-estado-propuesta-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
        IncidenciaModule
    ],
    declarations: [
        CrearContactoComponent,
        CrearContactoDialog,
        // OrdenEstadoPropuestaDialog,
        EditarContactoComponent,
        EditarContactoDialog,
        EliminarContactoComponent,
        AsignarContactoComponent,
        EliminarContactoDialog,
        AsignarContactoDialog,
        ContactoComponent,
        VerContactosComponent,
        DetalleContactoComponent
    ],
    providers: [
        ContactoService
    ],
    entryComponents: [
        CrearContactoDialog,
        EditarContactoDialog,
        EliminarContactoDialog,
        AsignarContactoDialog,
        // OrdenEstadoPropuestaDialog,
    ],
    exports: [
        CrearContactoComponent,
        EditarContactoComponent,
        EliminarContactoComponent,
        AsignarContactoComponent,
        ContactoComponent,
        VerContactosComponent
    ]
})
export class ContactoModule { }
